<!--站点创建修改页面-->
<template>
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :cancelText="$t('antd.table.close')"
      wrapClassName="ant-modal-cust-warp"
      style="top:5%;height: 85%;overflow-y: hidden">

      <a-spin :spinning="confirmLoading">
        <a-form-model ref="form"  v-bind="layout"  :model="model" :rules="validatorRules">
          <a-form-model-item :label="$t('dashboard.order.siteName')" required prop="name">
            <a-input v-model="model.name" :placeholder="$t('dashboard.order.placeholderSiteName')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.address')" required prop="address">
            <a-input v-model="model.address" :placeholder="$t('dashboard.analysis.plAddress')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.city')" required prop="city">
            <a-input v-model="model.city" :placeholder="$t('dashboard.analysis.plCity')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.contactPhone')"  prop="contactPhone">
            <a-input v-model="model.contactPhone" :placeholder="$t('dashboard.analysis.plContactPhone')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.countryCode')" required prop="countryCode">
            <a-input v-model="model.countryCode" :placeholder="$t('dashboard.analysis.plCountryCode')"/>
          </a-form-model-item>
          <a-form-model-item
              :label="$t('dashboard.analysis.businessTime')"
              required
          >
            <div style="display: flex; gap: 8px;">
              <!-- 选择星期范围（周一至周五） -->
              <a-select
                  v-model="model.startWeek"
                  style="width: 100px"
                  :placeholder="$t('dashboard.analysis.selectWeekdays')"
              >
                <a-select-option value="周一">周一</a-select-option>
                <a-select-option value="周二">周二</a-select-option>
                <a-select-option value="周三">周三</a-select-option>
                <a-select-option value="周四">周四</a-select-option>
                <a-select-option value="周五">周五</a-select-option>
                <a-select-option value="周六">周六</a-select-option>
                <a-select-option value="周日">周日</a-select-option>
              </a-select>
              <!-- 选择星期范围（周一至周五） -->
              <a-select
                  v-model="model.endWeek"
                  style="width: 100px"
                  :placeholder="$t('dashboard.analysis.selectWeekdays')"
              >
                <a-select-option value="周一">周一</a-select-option>
                <a-select-option value="周二">周二</a-select-option>
                <a-select-option value="周三">周三</a-select-option>
                <a-select-option value="周四">周四</a-select-option>
                <a-select-option value="周五">周五</a-select-option>
                <a-select-option value="周六">周六</a-select-option>
                <a-select-option value="周日">周日</a-select-option>
              </a-select>
              <!-- 选择时间范围（8:00-20:00） -->
              <a-time-picker
                  v-model="model.startTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  placeholder="开始时间"
                  :disabled-minutes="disabledMinutes"
                  :hide-disabled-options="true"
                  :minute-step="15"
              />
              <!-- 选择时间范围（8:00-20:00） -->
              <a-time-picker
                  v-model="model.endTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  placeholder="结束时间"
                  :disabled-minutes="disabledMinutes"
                  :hide-disabled-options="true"
                  :minute-step="15"
              />
            </div>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.businessCondition')" required prop="businessCondition">
            <a-select
                v-model="model.businessCondition"
                show-search
                :placeholder="$t('dashboard.analysis.placeholderBusinessCondition')"
                option-filter-prop="children"
                :filter-option="filterOption"
            >
              <a-select-option :value="0">  <!-- 确保这里是数字0 -->
                {{ $t('dashboard.analysis.resting') }}
              </a-select-option>
              <a-select-option :value="1">  <!-- 确保这里是数字1 -->
                {{ $t('dashboard.analysis.operating') }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.longitude')" required prop="longitude">
            <a-input v-model="model.longitude" :placeholder="$t('dashboard.analysis.placeholderLongitude')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.latitude')" required prop="latitude">
            <a-input v-model="model.latitude" :placeholder="$t('dashboard.analysis.placeholderLatitude')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.siteType')" required prop="siteType">
            <a-select v-model="model.siteType" :placeholder="$t('dashboard.analysis.placeholderSiteType')">
              <a-select-option value="cw">
                {{ $t('dashboard.analysis.centerWarehouse') }}
              </a-select-option>
              <a-select-option value="site">
                {{ $t('dashboard.analysis.site') }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.postalCode')" required prop="postalCode">
            <a-select
              v-model="model.postalCode"
              show-search
              :placeholder="$t('dashboard.analysis.plPostalCode')"
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option v-for="(item, index) in siteCodeData" :key="index" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.addressLink')" required prop="addressLink">
            <a-input v-model="model.addressLink" :placeholder="$t('dashboard.analysis.placeholderAddressLink')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.serviceRadius')"  prop="serviceRadius">
            <a-input v-model.number="model.serviceRadius" :placeholder="$t('dashboard.analysis.plServiceRadius')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('dashboard.analysis.stateProvince')"  prop="stateProvince">
            <a-input v-model="model.stateProvince" :placeholder="$t('dashboard.analysis.plStateProvince')"/>
          </a-form-model-item>
          <a-form-model-item label="袋号规则" prop="bagNumberRulesId">
            <a-select
              v-model="model.bagNumberRulesId"
              show-search
              placeholder="请选择袋号规则"
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option v-for="item in bagNumberRulesList" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
  </template>

  <script>
    import { siteCreate, siteUpdate} from 'api/app'
    import { getNumberIntervalList } from 'api/numberInterval'
    export default {
      name: "AisleModleCreate",
      props: {
        siteCodeData:{
          type: Array,
          required: true,
          default: () => []
        }
      },
      data () {
        return {
          title: this.$t('antd.table.batch'),
          visible: false,
          model: {},
          layout: {
            labelCol: { span: 7 },
            wrapperCol: { span: 14 },
          },
          confirmLoading: false,
          bagNumberRulesList: [], // 袋号规则列表
          validatorRules:{
            address: [
              { required: true, message: this.$t('dashboard.analysis.plAddress'), }
            ],
            city: [
              { required: true, message: this.$t('dashboard.analysis.plCity')}
            ],
            countryCode: [
                { required: true, message: this.$t('dashboard.analysis.plCountryCode')},
                { min: 1, max: 2, message: this.$t('dashboard.analysis.countryCodeDef'), trigger: 'blur' },
            ],
            name: [
              { required: true, message: this.$t('dashboard.order.siteName')}
            ],
            longitude: [
              { required: true, message: this.$t('dashboard.analysis.placeholderLongitude')}
            ],
            latitude: [
              { required: true, message: this.$t('dashboard.analysis.placeholderLatitude')}
            ],
            addressLink: [
              { required: true, message: this.$t('dashboard.analysis.placeholderAddressLink')}
            ],
            siteType: [
              { required: true, message: this.$t('dashboard.analysis.placeholderSiteType')}
            ],
            businessCondition: [
              { required: true, message: this.$t('dashboard.analysis.placeholderBusinessCondition')}
            ],
            postalCode: [
              { required: true, message: this.$t('dashboard.analysis.plPostalCode')}
            ]
          },
        }
      },
      created () {
        //备份model原始值
        this.modelDefault = JSON.parse(JSON.stringify(this.model));
        // 获取袋号规则列表
        this.getBagNumberRulesList();
      },
      methods: {
        // 禁止选择无效分钟（可选 00, 15, 30, 45）
        disabledMinutes(selectedHour) {
          if (selectedHour === 8 || selectedHour === 20) {
            // 8:00-8:59 和 20:00-20:59 只能选整点（避免跨出营业时间）
            return [15, 30, 45];
          }
          return [];  // 其他时间允许选择 00/15/30/45
        },
        filterOption(input, option) {
          return (
            option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
          );
        },
        add (options) {
          this.edit({...this.modelDefault, ...options});
        },
        edit (record) {
          this.model = Object.assign({}, record);
          this.visible = true;
          // 每次打开弹窗时重新获取袋号规则列表
          this.getBagNumberRulesList();
        },
        close () {
          this.$refs.form.clearValidate();
          this.$emit('close');
          this.visible = false;
        },
        handleOk () {
          const that = this;
          // 触发表单验证
          this.$refs.form.validate(valid => {
            if (valid) {
              that.confirmLoading = true;
              let obj;
              if(!this.model.id){
                obj=siteCreate(this.model);
              }else{
                obj=siteUpdate(this.model);
              }
              obj.then((res)=>{
                if(res.code == '200'){
                  that.$message.success(res.msg);
                  that.$emit('ok');
                }else{
                  that.$message.warning(res.msg);
                }
              }).finally(() => {
                that.confirmLoading = false;
                that.close();
              })
            }else{
              return false;
            }
          })
        },
        handleCancel () {
          this.close()
        },
        validateRoleCode(value, callback){
          if(/[\u4E00-\u9FA5]/g.test(value)){
            callback("角色编码不可输入汉字!");
          }else{
            // let params = {
            //   tableName: "sys_role",
            //   fieldName: "role_code",
            //   fieldVal: value,
            //   dataId: this.model.id,
            // };
            // duplicateCheck(params).then((res)=>{
            //   if(res.success){
            //     callback();
            //   }else{
            //     callback(res.message);
            //   }
            // });
          }
        },
        // 获取袋号规则列表
        getBagNumberRulesList() {
          const params = {
            type: 'site_pickup_bag_number'
          };
          getNumberIntervalList(params).then(res => {
            if (res.code == '200' && res.data) {
              this.bagNumberRulesList = res.data;
            } else {
              this.bagNumberRulesList = [];
            }
          }).catch(err => {
            console.error('获取袋号规则列表失败:', err);
            this.bagNumberRulesList = [];
          });
        }
      }
    }
  </script>

  <style scoped>

  </style>
